import { render, staticRenderFns } from "./data-overview.vue?vue&type=template&id=1407a74a&scoped=true"
import script from "./data-overview.vue?vue&type=script&lang=js"
export * from "./data-overview.vue?vue&type=script&lang=js"
import style0 from "./data-overview.vue?vue&type=style&index=0&id=1407a74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407a74a",
  null
  
)

export default component.exports